module.exports = __webpack_public_path__ + "static/img/4063_phase_function_Paper_PointsHejduk_Prediction.e52ad81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4063_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MK8x
// module chunks = 0